export default {
  data() {
    return {
      loading: false
    };
  },
  watch: {
    loading(val) {
      this.$store.commit("setLoading", val);
    }
  }
};
